const baseStyle = () => {
  return {
    alignItems: 'flex-start',
  };
};

export default {
  baseStyle,
};
